/* eslint-disable react-hooks/rules-of-hooks */
import ArrayInput from "app/utils/form/ArrayInput";
import { StepLoadContract2Props } from "../StepLoadContract2";
import { editStepGrid } from "../../form/step.service";
import { ActionDataGrid2 } from "../../form/ActionDataGrid2";
import { Formik } from "formik";
import { useState } from "react";
function renderDietaryCategory(params: any, inputCatagory: any) {
    const [data, setData] = useState([{ text: params.data.dietaryCategory, value: params.data.idDietaryCategory, tagLabel: params.data.dietaryCategoryAll }])
    return (<>
        <span className="title-category">{params.data.dietaryCategoryAll}</span>
        <Formik
            initialValues={{ dietaryCategory: data }}
            onSubmit={() => {
            }}
        >
            <ArrayInput arrayInput={[inputCatagory]} />
        </Formik>
    </>)
}
export const columnDefStep2 = (props: StepLoadContract2Props, callbackEdit: any, setDataRow2: any, dataRow2: any, setEditCategoryD:any): any => {
    return [
        { field: 'contrato', headerName: 'Contrato', minWidth: 120 },
        { field: 'fatherStructure', headerName: 'Estructura Padre', minWidth: 180, rowDrag: true },
        { field: 'id', hide: true },
        { field: 'structure', headerName: 'Estructura', minWidth: 150 },
        { field: 'plateType', headerName: 'Tipo de Plato', minWidth: 180 },
        { field: 'dietaryCategory', headerName: 'Categoría Dietética', minWidth: 260, hide: true },
        {
            headerName: 'Categoría Dietética', minWidth: 390,
            suppressRowTransform: true,
            cellClass: 'overflow-visible',
            cellRenderer: (params: any) => {
                if (params.data.load || props.bloqueado) {
                    setEditCategoryD(true);
                    
                    const propCat = props.data.categoriaDieteticaRec;
                    const inputCatagory: any =
                    {
                        columInput: 1,
                        campo: 'dietaryCategory',
                        label: '',
                        type: 'tree-select',
                        style: { width: '100%', zIndex: 5 },
                        treeData: propCat,
                        onChangeTree: async (
                            setFieldValue: any,
                            values: any,
                            arrayInput: any,
                            currentNode: any,
                            selectedNodes: any
                        ) => {
                            params.data.dietaryCategory = values.dietaryCategory[0].text
                            params.data.idDietaryCategory = values.dietaryCategory[0].value
                            params.data.dietaryCategoryAll = values.dietaryCategory[0].tagLabel
                            const editRow = dataRow2.map((item: any) => {
                                if (item.id === params.data.id) {
                                    item = params.data;
                                }
                                return item;
                            });
                            setDataRow2(editRow);
                        },
                        className: 'bootstrap-demo w-100',
                    }
                    return renderDietaryCategory(params, inputCatagory);

                } else {
                    setEditCategoryD(false);
                    
                    return (<span className="categoria-dietetica">{params.data.dietaryCategoryAll}</span>)
                }
            }
        },
        { field: 'tolerance', headerName: 'Intolerancia', minWidth: 150 },
        { field: 'allergens', headerName: 'Permite Alergenos', minWidth: 180 },
        { field: 'blockedDays', headerName: 'Días Bloqueados', minWidth: 180 },
        {
            field: 'Acción',
            minWidth: 150,
            cellRenderer: (params: any) => {
                if (!props.bloqueado) {
                    return <>
                        {!params.data.load ? editStepGrid(params, callbackEdit) : <></>}
                        {props.plantilla>0?<></>:<ActionDataGrid2 dataRow={params.node.data} />}
                    </>;
                } else {
                    return <></>
                }
            },
            cellEditor: 'agRichSelectCellEditor',
            cellEditorPopup: true,
        },
    ]
}